<div
  [id]="id + '30bc682b-cd74-4326-ad4c-76820d37712b'"
  class="panel-div spinner-dark"
  [class.delete-mode]="deleteMode === 'delete'"
  [class.delete-in-progress]="deleteMode === 'deleteInProgress'"
  [class.active]="defaultIcon === 'selected'"
  [class.no-hover]="disableHover"
  yatTabSelectable
  (tabSelect)="selectBillingAddress($event)"
  [yatSpinner]="selectMode === 'selectInProgress' || (spinnerShown && isMobile())"
  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
  [matomoClickAction]="matomoEventClickAction">
  <div [id]="id + '95cceccd-2a95-46a3-a6e2-426da5aca243'" class="row">
    <div [id]="id + 'c0404dfd-a298-485e-973c-2737656d2bec'" class="col-12" [class.minified]="minified">
      <div [id]="id + 'b33b3769-4584-42e0-8bb3-9afab651d842'" class="icons skeleton-hide">
        <span
          [id]="id + '5ec36429-1cd9-49ba-abb3-98f599b1c056'"
          class="no-select"
          yatTabSelectable
          (tabSelect)="prepareDelete()"
          *ngIf="showDeleteIcon && !isMobile()"
          [yatTooltip]="('delete' | commonWording | async) ?? ''"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
          matomoClickAction="Select_DeleteBillingAddress">
          <yat-icon id="c8f69243-f854-4ecf-9f7a-42b3b6d7e31f" [class.hover-icon]="!isMobile()" name="delete-duo"></yat-icon>
        </span>
        <span
          [id]="id + '55faa40f-1db2-45f2-83a3-4fd92cc8db00'"
          class="no-select"
          yatTabSelectable
          (tabSelect)="edit()"
          *ngIf="showEditIcon && !isMobile()"
          [yatTooltip]="('edit' | commonWording | async) ?? ''"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
          matomoClickAction="Select_EditBillingAddress">
          <yat-icon id="94a7808d-acf6-4e79-a354-064e5528c4f0" [class.hover-icon]="!isMobile()" name="edit-field-duo"></yat-icon>
        </span>
        <div [id]="id + '213516df-1b62-4476-bc46-7431a06bfcb3'" class="vr" *ngIf="(showDeleteIcon || showEditIcon) && !isMobile()"></div>
        <ng-container *ngIf="defaultIcon || isMobile(); else noDefaultIcon">
          <span [id]="id + '6e9ffe93-4010-4e96-a94e-ae7d3131259f'" class="icon-static" *ngIf="(isMobile() && showDeleteIcon) || !isMobile()">
            <yat-icon
              [class.hover-icon]="!isMobile()"
              class="p-1 fill-n-30"
              *ngIf="(defaultIcon === 'settings' || (isMobile() && defaultIcon === 'selected')) && !minified"
              name="cog-duo"></yat-icon>
            <yat-icon *ngIf="defaultIcon === 'selected'" name="tick-circle-duo" class="active"></yat-icon>
          </span>
        </ng-container>
        <ng-template #noDefaultIcon>
          <span [id]="id + '85c84e64-ca9e-4c39-87bd-953b62220465'">
            <yat-icon id="d6b587d2-2b8d-4753-84b6-3c1c2b1870bf" name="tick-circle-duo"></yat-icon>
          </span>
        </ng-template>
      </div>
      <yat-mobile-draw-dialog
        [id]="id + '5857c2fe-258f-42dd-b999-b3c1a4f9f294'"
        [showDialog]="deleteMode !== 'default' && isMobile() && (showDeleteIcon || showEditIcon)"
        [showSecondConfirmDialogFlag]="showSecondConfirmDialogFlag"
        (abortConfirmModal)="abortConfirmDelete()">
        <ng-container ngProjectAs="primaryMenu">
          <span
            [id]="id + 'e2f803a1-3d5e-4f2e-8c7b-90b78663b525'"
            yatTabSelectable
            (tabSelect)="edit()"
            [yatTooltip]="('edit' | commonWording | async) ?? ''"
            [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
            matomoClickAction="Select_EditBillingAddress">
            <yat-icon id="86e72206-9603-489a-9bb9-9036c5cdbbe5" name="edit-field-duo"></yat-icon> {{ 'edit' | commonWording | async }}
          </span>
          <span
            [id]="id + '52a364fd-13b8-4152-9480-23a05dfe7b73'"
            class="delete"
            yatTabSelectable
            (tabSelect)="showSecondConfirmDialog()"
            [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
            matomoClickAction="Select_DeleteBillingAddress">
            <yat-icon id="84fe8333-77a6-4bc5-9832-c11afc8e01d0" name="delete-duo"></yat-icon> {{ 'delete' | commonWording | async }}
          </span>
        </ng-container>
        <ng-container ngProjectAs="secondaryMenu">
          <p [id]="id + '5928d8c2-528d-4de4-8535-05f1cee4cdda'">
            {{ 'checkout.billingInformation.billingAddressModal.billingAddressConfirmDelete' | transloco }}
          </p>
          <div [id]="id + '5d5ab3a6-71a8-478c-86c2-addc93c99c5c'" class="buttons-container">
            <button
              [id]="id + 'f746e860-493a-45a9-a41b-bfb41b2c0ee3'"
              yat-button
              type="button"
              class="btn secondary-weak"
              (click)="abortConfirmDelete()"
              [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
              matomoClickAction="Cancel_DeleteBillingAddress">
              {{ 'cancel' | commonWording | async }}
            </button>
            <button
              [id]="id + 'd62c527f-e386-456f-b57c-f47edac4241b'"
              yat-button
              type="button"
              class="btn primary destructive"
              (click)="deleteItem()"
              [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
              matomoClickAction="Confirm_DeleteBillingAddress">
              {{ 'delete' | commonWording | async }}
            </button>
          </div>
        </ng-container>
      </yat-mobile-draw-dialog>
      <div *ngIf="!liveLicense" [id]="id + '115c50eb-9dad-4bfe-80b0-7c7f58acc7d7'" class="demo skeleton-hide">{{ 'demo' | commonWording | async }}</div>
      <p [id]="id + '034d944e-ca9b-45c4-8f07-2dbde208d896'" class="beside-icons" [class.demo-tag]="!liveLicense">
        <ng-container *ngIf="billingAddress.organizationName"
          ><span [id]="id + 'd15c5e65-c948-4b1a-805d-081c69600d26'" [class.font-bold]="minified">{{ billingAddress.organizationName }}</span>
          <br *ngIf="!minified" /><span
            [id]="id + '26478676-ed12-47fc-b95d-3c3e7f895dc1'"
            *ngIf="minified && (billingAddress.firstName || billingAddress.lastName)">
            ·
          </span>
        </ng-container>
        <ng-container *ngIf="billingAddress.firstName || billingAddress.lastName">{{ billingAddress.firstName }} {{ billingAddress.lastName }}</ng-container>
      </p>
      <p [id]="id + 'd7af11e0-751d-463a-be89-027c5d8d7767'" [class.minified]="minified" [class.demo-tag]="!liveLicense">
        <ng-container *ngIf="billingAddress.address">{{ billingAddress.address }}<br *ngIf="!minified" /></ng-container>
        <ng-container *ngIf="billingAddress.address2"><span *ngIf="minified"> · </span> {{ billingAddress.address2 }}<br *ngIf="!minified" /></ng-container>
        <ng-container *ngIf="billingAddress.city || billingAddress.postalCode || billingAddress.province"
          ><ng-container *ngIf="billingAddress.postalCode"><span *ngIf="minified"> · </span> {{ billingAddress.postalCode }} </ng-container>
          <ng-container *ngIf="billingAddress.city">{{ billingAddress.city }}</ng-container
          ><ng-container *ngIf="billingAddress.province"
            ><ng-container *ngIf="billingAddress.city || billingAddress.postalCode">, </ng-container>{{ billingAddress.province }}</ng-container
          ><br *ngIf="!minified"
        /></ng-container>
        <ng-container *ngIf="billingAddress.country">
          <ng-container *ngIf="minified"> ({{ billingAddress.country | country | async }})</ng-container>
          <ng-container *ngIf="!minified">{{ billingAddress.country | country | async }}</ng-container>
        </ng-container>
      </p>
      <p
        *ngIf="
          (billingAddress.email || billingAddress.vatId) &&
          (!minified || (!billingAddress.organizationName && !(billingAddress.firstName || billingAddress.lastName)))
        "
        [id]="id + '31ad3af0-0013-4328-8dab-9c4095d3d78f'">
        <span [id]="id + 'b36be058-8f76-4272-8327-d78a0a0d6fce'" class="email" *ngIf="billingAddress.email">
          <yat-email-clip [id]="id + 'a5247810-1cc2-497c-ab4d-eeadce74f424'" [email]="billingAddress.email"> </yat-email-clip
        ></span>
        <span [id]="id + '66d6ae54-e94c-4588-9a8b-8953da40836b'" class="c-gray d-block" *ngIf="billingAddress.vatId && !minified">
          {{ 'checkout.billingInformation.billingAddressPanel.vatId' | transloco: { vatId: billingAddress.vatId | vatId } }}
        </span>
      </p>
      <p *ngIf="billingAddress.vatVerified === false" class="vat-warning">
        {{ 'checkout.billingInformation.billingAddressPanel.vatNotVerified' | transloco }}
      </p>
      <yat-icon
        class="chevron-icon"
        *ngIf="
          (isMobile() && !showDeleteIcon && (liveLicense || defaultIcon === 'settings') && billingAddress.contractIdsForConnectedSubscriptions.length < 1) ||
            (minified && isMobile());
          else cog
        "
        name="chevron-right">
      </yat-icon>
      <ng-template #cog>
        <yat-icon
          class="cog-icon"
          [class.demo-tag]="!liveLicense"
          *ngIf="!isMobile() && (!showDeleteIcon || !showEditIcon) && defaultIcon === 'settings'"
          name="cog-duo"></yat-icon>
      </ng-template>
    </div>
  </div>
  <yat-confirm-buttons
    [id]="id + 'ecd588ca-e3d1-46c4-ac0f-c7e63dbfaa48'"
    [confirmButtonName]="('delete' | commonWording | async) ?? ''"
    class="no-select"
    (confirmClickMethod)="delete($event)"
    (cancelClickMethod)="abortConfirmDelete()"
    *ngIf="deleteMode !== 'default' && !isMobile()"></yat-confirm-buttons>
</div>
